import { X } from "lucide-react";
import { displayUserType } from "../types/User"
import { useTranslation } from "../i18n";
import { useReadOnly } from "../access/ReadOnly";
import "../styles/add-user.css";

const DeleteUser = ({ user, deleteUser, toggleDelete }: { user: displayUserType, deleteUser: (userToDelete: displayUserType) => Promise<void>, toggleDelete: (user: displayUserType | null) => void }) => {
    const { t } = useTranslation();
    // Access-control read-only handheld mode (ACCESS_CONTROL_PLAN.md §8.4).
    const readOnly = useReadOnly();

    return (
        <div className="modal-overlay" onClick={() => toggleDelete(null)}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="modal-card-header">
                    <h2>{t("delete_user")}</h2>
                    <button className="modal-close" onClick={() => toggleDelete(null)}>
                        <X size={18} />
                    </button>
                </div>
                <div className="modal-card-body">
                    <p className="modal-confirm-text">{user.name}<br />{t("delete_confirm")}</p>

                    <div className="modal-confirm-buttons">
                        <button
                            className="btn btn-danger"
                            onClick={() => deleteUser(user)}
                            disabled={readOnly}
                            aria-disabled={readOnly}
                            title={readOnly ? t("read_only_mode") : undefined}
                        >{t("yes")}</button>
                        <button className="btn btn-ghost" onClick={() => toggleDelete(null)}>{t("no")}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteUser;
